export default __webpack_public_path__ + "static/media/organicindia_1225x150px.67d2e68d.png";